import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { NewInspectionService } from '../../../../inpsection.service';
import { ObservationImagesViewModel,
  InspectionObservationPointsViewModel,
  PhotoModelComingFrom,
  CommentModelComingFrom,
  QuestionModelComingFrom} from '../../../../inspection.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ObservationQuestionsComponent } from '../observation-questions/observation-questions.component';
import { MatDialog } from '@angular/material/dialog';
import { GETViewPhotoComponent } from '../../../../../shared/view-photo/view-photo.component';
import { NotificationsService } from 'angular2-notifications';
import { GETPreferencesService } from '../../../../../../../modules/GET_NEW_UI/preferences/preferences.service';
import { ComponentVM } from '../../../../../setup-implement/setup-implement.model';
import { ImplementDetailsService } from '../../../../../implement-details/implement-details.service';
import { SetupImplementService } from '../../../../../setup-implement/setup-implement.service';
import { ObservationPointVM } from '../../../../../favourite-dialog/favourite-dialog-modal';
import { AddCrackObsPointDialogComponent } from '../../../../../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { SchematicAndObservationPointDetails, SchematicDetails } from '../../../../../equipment-details/equipment-details.model';


@Component({
  selector: 'app-view-observation-point-row',
  templateUrl: './view-observation-point-row.component.html',
  styleUrls: ['./view-observation-point-row.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class ViewObservationPointRowComponent implements OnInit {

  @Input() observationPointInspectionId: number;
  @Input() implementID: number = 0;
  @Input() implementInspectionId: number = 0;
  @Input() inspectionDate: Date;
  @Input() Residual:number;
  photoComingFrom = PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel;
  commentComingFrom = CommentModelComingFrom.Interpretation;
  observation: InspectionObservationPointsViewModel;
  observationList: InspectionObservationPointsViewModel[]=[];
  loadingRow = true;
  openingEditPopup = false;
  userPref: string;
  showPopup: boolean = false;
  showQPopup: boolean = false;
  componentList: ComponentVM[];
  constructor(
    private _inspectionService: NewInspectionService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _toaster: NotificationsService,
    public _getPrefrencesService:GETPreferencesService,
    private _moduleService: ImplementDetailsService,
    private _implementService: SetupImplementService
  ) { }

  ngOnInit() {
   // this.loadingRow=true;
    this.loadData();
    this.getUserPref();
  }



  loadData() {
    this.loadingRow=true;
    this._inspectionService.getObservationPointInspection(this.observationPointInspectionId).subscribe(r => {
      this.observation = r;
     // let arrayObs = [];
     // arrayObs.push(this.observation);
     // this.observationList=arrayObs;
      console.log("details___AAAA", this.observation)
      this.loadingRow = false;
      if(this.observation.ObsList?.length > 0 && this.observation.ObservationTypeName === 'Crack'){
        this.observation.obsId =  this.observation.severityIDs?.[0] ?? null;
        console.log("this.observation.obsId",this.observation.obsId);
      }
    });
  }

  ToggleObsFlag(ObservationInspectionId:number,flag:boolean){
    if(this.observationPointInspectionId>0){
      this._inspectionService.UpdateObservationInspectionFlag(ObservationInspectionId,flag).subscribe(r=>{
        if (r.m_Item1) {
          this._toaster.success(r.m_Item2);
          this.loadData();
      } else {
          this._toaster.error(r.m_Item2);
      }
      })
    }
  }

  DeleteObsMeasurement(ObservationInspection:InspectionObservationPointsViewModel){
    if(ObservationInspection.Id>0){
//check reading ID
let ObsMeasurementReadiingId = ObservationInspection.ObservationMeasurements[0].Id;

      this._inspectionService.RemoveObservationMeasurment(ObsMeasurementReadiingId).subscribe(r=>{
        if (r.m_Item1) {
          this._toaster.success(r.m_Item2);
          this.loadData();
      } else {
          this._toaster.error(r.m_Item2);
      }
      })
    }
  }

  toggleObservationPointIncludeReport(ObservationId: number) {
    if (ObservationId > 0) {
        this._inspectionService.toggleObservationInspectionIncludeReport(ObservationId).subscribe((r: any) => {
            if (r.m_Item1) {
                this._toaster.success(r.m_Item2);
            } else {
                this._toaster.error(r.m_Item2);
            }
        });
    }
}

  getImage(image: string) {
    if (image != null && image !== undefined) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }
  }
  getEvalClass(worn: number) {
    return this._inspectionService.getEvalClass(worn);
  }
  getEvalClass2(worn: number) {
    return this._inspectionService.getEvalClass2(worn);
  }

  getEvalCode(value: number): string {
    if (value == 15) return 'A';
    if (value == 45) return 'B';
    if (value == 70) return 'C';
    if (value == 85) return 'X';
    if (value == 0) return  'U';
}

  photoRecevied(image, ObservationPoint: InspectionObservationPointsViewModel) {
    // const newPhoto = new ObservationImagesViewModel(image);
    // if (ObservationPoint.ObservationImages !== undefined) {
    //   ObservationPoint.ObservationImages.push(newPhoto);
    // }    else {
    //   ObservationPoint.ObservationImages = [];
    //   ObservationPoint.ObservationImages.push(newPhoto);
    // }
    this.loadData()
  }

  commentChanged(comment, ObservationPoint: InspectionObservationPointsViewModel) {
   // console.log(comment);
  }

  measurementChanged(event) {
    //console.log(event);
 
    if (event) {
      this.loadData();
    }
  }


  viewObservationImages(image: ObservationImagesViewModel) {
    const passingData = {
          comingFrom: PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel,
          inspectionObservationPoint: this.observation,
          image: image,
    };
    //console.log('passingData',passingData)

    const viewCommentModalRef = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,

    });
    viewCommentModalRef.afterClosed().subscribe(changes => {
      if (changes) {
        this.loadData();
      }
    });
  }

  shouldHighlight(ObservationPoint: InspectionObservationPointsViewModel): boolean {
    if (ObservationPoint.QuestionTitle === undefined || ObservationPoint.QuestionTitle === null || ObservationPoint.QuestionTitle.length == 0) {
      return false;
    }
    return true;
  }

  shouldHighlightQandI(ObservationPoint: InspectionObservationPointsViewModel): boolean {
    if ((ObservationPoint.QuestionInstruction === undefined || ObservationPoint.QuestionInstruction === null || ObservationPoint.QuestionInstruction.length == 0) && (ObservationPoint.Image == null || ObservationPoint.Image.length == 0))
      return false;
    return true;
  }

  getUserPref(){
    this._getPrefrencesService.getUserPreferences().subscribe(r => {
      this.userPref = r.UnitOfMeasurementName;
      console.log("userPref",this.userPref);
    })  
  }


  openObservationQuestions(ObservationPoint: InspectionObservationPointsViewModel) {
    const passingData = {
          comingFrom: QuestionModelComingFrom.Interpretation,
          observation: ObservationPoint,
    };

    const viewCommentModalRef = this._dialog.open(ObservationQuestionsComponent, {
      width: '1032px',
      data: passingData,
    });
    viewCommentModalRef.afterClosed().subscribe(changes => {
      if (changes) {
          // this.comment = reloadComment;
          // this.observationPoint.Comments = reloadComment;
          // this.onCommentChange.emit(reloadComment);
      }
    });
  }

  updateCrackSeverity(observationPointInspectionID, severityID){
    this._inspectionService.UpdatCrackSeverityOnObservationPoint(observationPointInspectionID, severityID)
    .subscribe( a => {    
      //console.log("aaaa",a);
      this._toaster.success("Severity updated Successfully.")
      //this._inspectionService.mySubject.next(true);
    });
  }

  updateObsSeverity(observationPointInspectionID, severityIDs) {
    console.log("severityIDs:", severityIDs)
    console.log("this.observation:", this.observation)
    const severityIdArray = Array.isArray(severityIDs) ? severityIDs : severityIDs != null ? [severityIDs] : [];
    this._inspectionService.UpdatObsSeveritiesOnObservationPoint(observationPointInspectionID, severityIdArray).subscribe(a => {
      //console.log("aaaa",a);
      if (a > 0) {
        this._toaster.success("Severity updated Successfully.")
        //this._inspectionService.mySubject.next(true);
      }
      else
        this._toaster.error("Failed to update severity.")
    });
  }

  openPopup() {
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }

  getImageUrl(image: string): any {
    if (!image) return null;

    const isDataUrl = image.startsWith('data:image');
    return isDataUrl ? image : this._sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${image}`);
  }

  openQPopup() {
    this.showQPopup = true;
  }

  closeQPopup() {
    this.showQPopup = false;
  }

  
  openSchematicWindow() {
    this.openingEditPopup = true;
    let arr_ = [];
    var SchematicImage = new SchematicAndObservationPointDetails();
    this._moduleService.getSchematicsObservationPointsDetails(this.implementID, this.observation.SchematicId).subscribe(details => {
      SchematicImage.ObservationPoints = details;
      console.log("SchematicImage.ObservationPoints", SchematicImage.ObservationPoints);
      this._moduleService.getSchematicImageBaseString(this.observation.SchematicId).subscribe(r => {
        if (r) {
          if (!SchematicImage.Schematic) {
            SchematicImage.Schematic = new SchematicDetails();  // or {} if you don't have a class
          }
          SchematicImage.Schematic.Data = r;
        }
        this._implementService.ReturnGETSchematicComponents(this.implementID, this.observation.SchematicId).subscribe(result => {
          this.componentList = result
          //this.loadComponentList(SchematicImage.Schematic.Id);
    SchematicImage.ObservationPoints.map(x => {
      var neModl = new ObservationPointVM();
      neModl.ObservationPointId = x.Id;
      neModl.ObservationPointPosX = x.PositionX;
      neModl.ObservationPointPosY = x.PositionY;
      neModl.EndObservationPointPosX = x.EndPositionX;
      neModl.EndObservationPointPosY = x.EndPositionY;
      neModl.isCrackFixed = x.IsCrackFixed;
      neModl.ObservationPointName = x.Name;
      neModl.observationPointTypeId = x.ObPointTypeId;
      neModl.WornPct = x.WornPct;
      neModl.InspectionDate = x.InspectionDate;
      neModl.pointLedgend = 3;
      neModl.CrackStatusId = x.CrackStatusId;
      neModl.ColorCode = x.ColorCode;
      arr_.push(neModl)
    });
          this.openingEditPopup = false;
    const addSectionDialog = this._dialog.open(AddCrackObsPointDialogComponent, {
      width: '1300px',
      //height: '1075px',
      disableClose: true,
      data: {
        obsDetails: arr_,
        schematic: SchematicImage.Schematic.Data,
        componentList: this.componentList,
        schematicId: SchematicImage.Schematic.Id,
        IsGETInspection: true,
        inspectionDate: this.inspectionDate,
        implementInspectionId: this.implementInspectionId,
        obsDetailExisting: this.observation
      }
    });
    addSectionDialog.afterClosed().subscribe(ObsID => {
      if (ObsID > 0) {
              //console.log("details", ObsID)
        //this.loadImplementDetails();
        //      this.getInspectionComponents();
      } else {

      }
    });
        });
      });
    });
  }



}
